"use client"

import SearchIcon from "@layout/icons/SearchIcon"
import { cn } from "@utils/utils"

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  className?: string
  children?: React.ReactNode
}

export const SearchBar = ({ value, onChange, placeholder, className, children }: SearchBarProps) => {
  return (
    <div className={cn("relative w-full", className)}>
      <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#1C1B1F] lg:left-6 lg:h-7 lg:w-7" />

      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="h-auto w-full cursor-text rounded-[20px] border border-neutral-10 bg-[#F5F5F5] py-4 pl-10 pr-4 text-[16px] font-normal leading-[1.2] tracking-[-0.02em] text-on-surface outline-none placeholder:text-[15px] placeholder:text-[#6B6F67] focus:border-primary-50 lg:py-6 lg:pl-14 lg:pr-8"
      />
      {children && <div className="absolute right-4 top-1/2 z-10 -translate-y-1/2 lg:right-6">{children}</div>}
    </div>
  )
}
